// The candidate's CV, shown inside the profile card. Delegates the whole
// filename + Preview + Download row to the shared ATS `ViewFile` (which owns
// the PDF preview modal and the download-with-toast), so resumes look and
// behave the same here as everywhere else in the product.

import { Flex } from '@chakra-ui/react';
import { ViewFile } from '@/components/ats';
import type { ResumeSectionProps } from './ResumeSection.types';

export const ResumeSection = ({ resumes }: ResumeSectionProps) => {
  const withUrl = resumes.filter((r) => r.url);
  if (withUrl.length === 0) return null;

  return (
    <Flex direction="column" gap="6px" data-test-id="agentforge-resume-section">
      {withUrl.map((r) => (
        <ViewFile
          key={r.id}
          file={{
            url: r.url,
            file_name: r.fileName,
            content_type: r.contentType,
          }}
          showIcon
        />
      ))}
    </Flex>
  );
};
